import { render, staticRenderFns } from "./TheAttachmentBtn.vue?vue&type=template&id=fa107f50&scoped=true"
import script from "./TheAttachmentBtn.vue?vue&type=script&lang=ts"
export * from "./TheAttachmentBtn.vue?vue&type=script&lang=ts"
import style0 from "./TheAttachmentBtn.vue?vue&type=style&index=0&id=fa107f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa107f50",
  null
  
)

export default component.exports